/*------------------------------------------------------------------
Import External Modules
------------------------------------------------------------------*/

import { each, nodeArray } from 'meteora';
// import SimpleSelector from 'simple-selector';

/*------------------------------------------------------------------
Import Internal Modules
------------------------------------------------------------------*/

import Form from '../classes/form';
import PlaceholderLabels from '../classes/placeholder-labels';

/*------------------------------------------------------------------
Form validation and submissions
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', function () {
  // form validation
  each('.js-form form', function (el) {
    var controller = {};
    var init = function init(form) {
      // Find the form's parent element
      controller.parent = form.parentNode;
      // We will store the server response here
      controller.response = null;
      // target the form's message area
      controller.message = document.createElement('p');
      // Add a class and some default styles
      controller.message.style.display = 'none;';
      controller.message.classList.add('message');
      // Prepend the form message element
      form.insertBefore(controller.message, form.firstElementChild);

      // Make the selects look nice :) 
      // nodeArray(form.querySelectorAll('select')).forEach((select) => new SimpleSelector(select));

      // Create some placeholders
      new PlaceholderLabels(form);
    };
    controller.Form = new Form(el, {
      recaptcha: true,
      messages: false,
      success: function success(Form, response) {
        try {
          // Try get a JSON response
          controller.response = JSON.parse(response);
          // Append the response message
          controller.message.innerHTML = controller.response.message;
          // Add a success class
          controller.message.classList.add('success');
        } catch (err) {
          // Replace the existing form with a new one
          controller.parent.innerHTML = response;
          // initialise the new form
          Form.setup(controller.parent.querySelector('form'));
          // Run our specific form functions
          init(Form.form);
        }
      }
    });
    init(el);
  });
});